import { DEPARTMENT_TYPES } from "./types"
import useJwt from "@src/auth/jwt/useJwt"

const config = useJwt.jwtConfig

const initialState = {
  departments: [],
  error: null,
  created: false,
  deleted: false,
  updated: false,
  createdUpdatedLoading: false,
  deletedLoading: false
}

const departmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEPARTMENT_TYPES.GET_ALL_DEPARTMENTS_REQUEST:
      return {
        ...state,
        error: null,
        created: false,
        deleted: false,
        updated: false
      }

    case DEPARTMENT_TYPES.GET_ALL_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departments: action.payload,
        createdUpdatedLoading: false,
        deletedLoading: false
      }

    case DEPARTMENT_TYPES.GET_ALL_DEPARTMENTS_FAIL:
      return {
        ...state,
        error: action.payload
      }

    case DEPARTMENT_TYPES.CREATE_DEPARTMENT_REQUEST:
      return {
        ...state,
        createdUpdatedLoading: true,
        error: null,
        created: false
      }

    case DEPARTMENT_TYPES.CREATE_DEPARTMENT_SUCCESS:
      if (localStorage.getItem(config.currentPlan) !== "advance") {
        localStorage.setItem(
          "currCreateDepartmentLimit",
          action.payload?.current
            ? action.payload?.current
            : localStorage.getItem("currCreateDepartmentLimit") > 0
            ? localStorage.getItem("currCreateDepartmentLimit") - 1
            : 0
        )
      }

      return {
        ...state,
        createdUpdatedLoading: false,
        created: true
      }

    case DEPARTMENT_TYPES.CREATE_DEPARTMENT_FAIL:
      return {
        ...state,
        error: action.payload,
        createdUpdatedLoading: false,
        created: false
      }

    case DEPARTMENT_TYPES.UPDATE_DEPARTMENT_REQUEST:
      return {
        ...state,
        createdUpdatedLoading: true,
        error: null,
        updated: false
      }

    case DEPARTMENT_TYPES.UPDATE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        updated: true,
        createdUpdatedLoading: false
      }

    case DEPARTMENT_TYPES.UPDATE_DEPARTMENT_FAIL:
      return {
        ...state,
        error: action.payload,
        createdUpdatedLoading: false,
        updated: false
      }

    case DEPARTMENT_TYPES.DELETE_DEPARTMENT_REQUEST:
      return {
        ...state,
        deletedLoading: true,
        error: null,
        deleted: false
      }

    case DEPARTMENT_TYPES.DELETE_DEPARTMENT_SUCCESS:
      if (localStorage.getItem(config.currentPlan) !== "advance") {
        localStorage.setItem(
          "currCreateDepartmentLimit",
          action.payload?.current
            ? action.payload?.current
            : localStorage.getItem("currCreateDepartmentLimit") <
              localStorage.getItem("createDepartmentLimit")
            ? localStorage.getItem("currCreateDepartmentLimit") + 1
            : 0
        )
      }

      return {
        ...state,
        deleted: true,
        deletedLoading: false
      }

    case DEPARTMENT_TYPES.DELETE_DEPARTMENT_FAIL:
      return {
        ...state,
        error: action.payload,
        deletedLoading: false,
        deleted: false
      }

    default:
      return state
  }
}

export default departmentReducer
